var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isLoginPage)?_c('AuthenticationComponent'):[_c('div',{staticClass:"main-wrapper"},[_c('header-component'),_c('router-view'),_c('footer-component')],1)],_c('notifications',{attrs:{"group":"success"}}),_c('notifications',{attrs:{"group":"error"}}),_c('notifications',{attrs:{"group":"warning"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }